import { render, staticRenderFns } from "./membershipLotsEdit.vue?vue&type=template&id=56324dc5"
import script from "./membershipLotsEdit.vue?vue&type=script&lang=js"
export * from "./membershipLotsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports